/* eslint-disable no-unused-vars */
import ButtonML from '@/components/button_ml/ButtonML';
import Dropdown from '../dropdown_ml/Dropdown';
import styles from './action.less?modules';
import { useTrigger } from '@/utils/comHook.js';
import Edit from '../modal/edit/Edit';
import ModalML from '@/components/modal_ml/ModalML';
import ModalConfirmML from '@/components/modal_ml/modal_confirm_ml/ModalConfirmML';
import { useContext } from 'react';
import { FunctionContext } from '../../index';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { useDispatch } from 'dva';
const Action = (props) => {
  const trigger = useTrigger();
  const trigger2 = useTrigger();
  const { singleListInfo } = props;
  const { fetchData } = useContext(FunctionContext);
  const dispatch = useDispatch();
  const applyForRelease = (id) => {
    dispatch({
      type: 'dvm/applyForRelease',
      payload: {
        id,
      },
      callback: () => {
        message.success('申请发布成功');
        fetchData();
        trigger2.close();
      },
    });
  };
  const handleOk = () => {
    applyForRelease(singleListInfo.id);
  };
  const handleCancel = () => {
    trigger2.close();
    message.info('已取消发布');
  };
  const menuClick = (a, b) => {
    if (a === '3') {
      return;
    } else if (a === '2') {
      dispatch({
        type: 'dvm/setToCurrentVersion',
        payload: {
          id: b.id,
        },
        callback: () => {
          message.success('设置成功');
        },
      });
    }
  };
  return (
    <div className={styles.handle_btn}>
      {/* {
        singleListInfo.versionStatus !== 'RUNNING' ?
        <ModalConfirmML
          title="是否进行版本发布?"
          handleOk={handleOk}
          handleCancel={handleCancel}
          visible={trigger2.visible}
          value="申请发布"
          icon={<ExclamationCircleOutlined />}
        /> : null
      } */}
      <ModalConfirmML
        title="是否进行版本发布?"
        handleOk={handleOk}
        handleCancel={handleCancel}
        visible={trigger2.visible}
        disabled={
          singleListInfo.versionStatus === 'RUNNING' ||
          singleListInfo.approvalStatus === 'PENDING_APPROVAL'
        }
        value="申请发布"
        icon={<ExclamationCircleOutlined />}
      />
      <ButtonML
        size="large"
        value="编辑"
        onClick={trigger.open}
        disabled={singleListInfo.versionStatus === 'RUNNING'}
      />
      {/* <ButtonML size="large" value="其他操作" fontsize="14px" /> */}
      <Dropdown
        size="large"
        title="其他操作"
        fontsize="14px"
        item={singleListInfo}
        menuClick={menuClick}
      />
      <ModalML
        title="编辑"
        handleOk={trigger.open}
        handleCancel={trigger.close}
        visible={trigger.visible}
      >
        <Edit
          handleOk={trigger.open}
          handleCancel={trigger.close}
          singleListInfo={singleListInfo}
        />
      </ModalML>
    </div>
  );
};
export default Action;
